import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import HeaderLogo from './headerlogo';
import HeaderNav from './headernav';
import TopHeader from './topheaderbar';
import './header.css';

export default function Header() {
  const location = useLocation();
  const [hideTop, setHideTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setHideTop(window.scrollY > 80);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header id="header" className={location.pathname === '/' ? 'home-header' : ''}>
        <div className={`top-header ${hideTop ? 'hidden' : ''}`}>
          <TopHeader />
        </div>
        <div className={`main-header ${hideTop ? 'sticky' : ''}`}>
          <Container className="theme-container">
            <Row className="align-items-center">
              <Col md="auto">
                <HeaderLogo />
              </Col>
              <Col md="auto" className="ms-auto">
                <HeaderNav />
              </Col>
            </Row>
          </Container>
        </div>
      </header>

      <div className="header-spacer"></div>
    </>
  );
}
